import { render, staticRenderFns } from "./projectPropertiesCard.vue?vue&type=template&id=de9debde"
import script from "./projectPropertiesCard.vue?vue&type=script&lang=js"
export * from "./projectPropertiesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports